import { ToastrService } from './toaster.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ErrorLogService {

    constructor(private toastr: ToastrService) {
    }

    /**
     * log the given error to various aggregation and tracking services.
     *
     * @param {*} error
     * @memberOf ErrorLogService
     */
    public logError(error: any): void {

        // Internal tracking.
        this.sendToConsole(error);
    }

    /**
     * Send the error the browser console (safely, if it exists).
     *
     * @param {*} error
     * @memberOf ErrorLogService
     */
    private sendToConsole(error: any): void {

        if (console && console.group && console.error) {

            console.group('Error Log Service');
            // if custom error exists then show message, else show generic error
            try {
                const e = error.json().Error;

                if (e && e.Code > 900) {
                    this.toastr.showErrorMessage(e.Value);
                } else {
                    this.toastr.showErrorMessage('Error!');
                }
            } catch (e) {

            }

            console.error(error);
            console.groupEnd();
        }
    }
}
